import React from 'react';
import { useTranslation, UseTranslationResponse } from 'react-i18next';
import { useMemoOne } from 'use-memo-one';
import { InboxClient } from '../Clients';
import InboxConfigContext from '../InboxConfigProvider';

export function useInboxClient(): InboxClient {
    const ctx = React.useContext(InboxConfigContext);
    const inboxClient = useMemoOne(
        () => new InboxClient(ctx.loginEmail, ctx.baseUrl, ctx.onTokenRequest),
        [ctx.baseUrl, ctx.onTokenRequest, ctx.loginEmail],
    );
    React.useEffect(() => {
        return inboxClient.dispose;
    }, [inboxClient]);
    return inboxClient;
}

export function useInboxTranslation(): UseTranslationResponse<'inbox-ui'> {
    return useTranslation('inbox-ui');
}
